var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFlagCircleRounded = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5395_119402)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.25 7.7H7l.508 1.015a.606.606 0 0 0 .262.289c.117.064.24.096.367.096H10.5a.678.678 0 0 0 .5-.202.675.675 0 0 0 .2-.498V5.6a.676.676 0 0 0-.202-.499.68.68 0 0 0-.498-.201H9.1l-.508-1.015a.606.606 0 0 0-.262-.29.744.744 0 0 0-.367-.095H4.9a.676.676 0 0 0-.498.201.68.68 0 0 0-.202.499v6.475a.51.51 0 0 0 .525.525c.151 0 .277-.05.377-.15.1-.098.149-.224.148-.375V7.7ZM7 14a6.813 6.813 0 0 1-2.73-.552 7.082 7.082 0 0 1-2.222-1.496A7.055 7.055 0 0 1 .551 9.73 6.832 6.832 0 0 1 0 7a6.8 6.8 0 0 1 .552-2.73 7.085 7.085 0 0 1 1.495-2.223A7.059 7.059 0 0 1 4.27.551 6.82 6.82 0 0 1 7 0 6.82 6.82 0 0 1 9.73.55a7.059 7.059 0 0 1 2.223 1.496c.629.63 1.127 1.37 1.496 2.223.369.852.552 1.762.551 2.73a6.865 6.865 0 0 1-.552 2.73 7.023 7.023 0 0 1-1.495 2.222A7.112 7.112 0 0 1 9.73 13.45c-.85.368-1.76.552-2.73.55Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5395_119402"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h14v14H0z"
  })))));
};
export default SvgFlagCircleRounded;